/* eslint-disable no-unused-vars */
/** Scroll to top when changing filter or numbers */
(function($) {
	document.addEventListener('facetwp-loaded', function() {
		$([document.documentElement, document.body]).animate({
			// scrollTop: $(".product-archive__top-bar").offset().top
			// scrollTop: 0,
		}, 200);
	});
})(jQuery);
(function($) {
	document.addEventListener('facetwp-loaded', function() {
		// eslint-disable-next-line no-undef
		fUtil('body').trigger('jetpack-lazy-images-load');
	});
})(jQuery);
